export default __webpack_public_path__ + "a24f79061df76260625d709d82e9ea90.png";